import { render, staticRenderFns } from "./TokenisedPhrase.vue?vue&type=template&id=64a1336d&scoped=true&"
import script from "./TokenisedPhrase.vue?vue&type=script&lang=ts&"
export * from "./TokenisedPhrase.vue?vue&type=script&lang=ts&"
import style0 from "./TokenisedPhrase.vue?vue&type=style&index=0&id=64a1336d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64a1336d",
  null
  
)

export default component.exports